import React from "react";
import { formatInTimeZone } from "date-fns-tz";
import { Link } from "react-router-dom";
import { withStyles } from "@mui/styles";
import ChatBubble from "@mui/icons-material/ChatBubble";

const styles = (theme) => ({
  availabilityRequest: {
    width: "100%",
    backgroundColor: "#fff",
    padding: 15,
    borderBottom: "1px solid #e6e5e5",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    color: "#000000",
    fontSize: "18px",
    lineHeight: "21px",
  },
  subtitle: {
    color: "#666666",
    fontSize: "14px",
    lineHeight: "16px",
    marginTop: "4px",
  },
  responseCounter: {
    padding: "4px 12px",
    borderRadius: "4px",
    fontSize: "14px",
    fontWeight: "600",
    whiteSpace: "nowrap",
  },
  contentWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    flex: 1,
  },
  messageBadge: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#2CB045",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    flexShrink: 0,
  },
  messageBadgeIcon: {
    color: "#fff",
    fontSize: "20px",
  },
  badgeCount: {
    position: "absolute",
    top: "-5px",
    right: "-5px",
    backgroundColor: "#FF3B30",
    borderRadius: "50%",
    width: "22px",
    height: "22px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "bold",
    color: "#fff",
  },
  buttonWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
});

function AvailabilityRequest({
  classes,
  availabilityRequest,
  actionButton,
  to,
  unreadMessageCount,
  respondedCount,
  totalCount,
}) {
  return (
    <div className={classes.availabilityRequest}>
      <Link to={to} style={{ display: "flex", alignItems: "center", flex: 1, textDecoration: "none" }}>
        <div className={classes.contentWrapper}>
          {unreadMessageCount > 0 && (
            <div style={{ position: "relative" }}>
              <div className={classes.messageBadge}>
                <ChatBubble className={classes.messageBadgeIcon} />
              </div>
              <div className={classes.badgeCount}>{unreadMessageCount}</div>
            </div>
          )}
          <div>
            {availabilityRequest.name && (
              <div className={classes.title}>{availabilityRequest.name}</div>
            )}
            {availabilityRequest.eventDate && (
              <div className={classes.title}>
                {formatInTimeZone(
                  availabilityRequest.eventDate,
                  "UTC",
                  "do MMMM yyyy"
                )}
              </div>
            )}
          </div>
        </div>
      </Link>
      <div className={classes.buttonWrapper}>
        {respondedCount !== undefined && totalCount !== undefined && (
          <div
            className={classes.responseCounter}
            style={{
              backgroundColor: respondedCount === totalCount ? "#07843e" : "#FF9500",
              color: "#fff",
            }}
          >
            {respondedCount} / {totalCount} responded
          </div>
        )}
        {actionButton}
      </div>
    </div>
  );
}

export default withStyles(styles)(AvailabilityRequest);
